/**
 * その他の情報
 */
export class OthersInfo {
    // private変数 --------------------------------------------------------
    private m_UnderWriter: string = null; // 引受保険会社
	private m_Agency: string = null; // 取扱代理店
	private m_Url: string = null; // URL
	// --------------------------------------------------------------------

	// プロパティ --------------------------------------------------------------------
	/** 引受保険会社 */
	public get underWriter(): string { return this.m_UnderWriter; } public set underWriter(underWriter: string) { this.m_UnderWriter = underWriter; }
	/** 取扱代理店 */
	public get agency(): string { return this.m_Agency; } public set agency(agency: string) { this.m_Agency = agency; }
	/** URL */
	public get url(): string { return this.m_Url; } public set url(url: string) { this.m_Url = url; }
	// --------------------------------------------------------------------

	// コンストラクタ --------------------------------------------------------
	constructor() { }
	// ------------------------------------------------------------------------
}